import { combineLatest, Observable, ObservableInput, OperatorFunction } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';

import { PricingFeatureLoadedModel, PricingFeatureModel } from '../types/pricing-feature.types';

export const ready: OperatorFunction<PricingFeatureModel, PricingFeatureLoadedModel> = (
  source: Observable<PricingFeatureModel>,
) => source.pipe(filter<PricingFeatureLoadedModel>(({ loaded }) => loaded));

export const readyOnce: OperatorFunction<PricingFeatureModel, PricingFeatureLoadedModel> = (
  source: Observable<PricingFeatureModel>,
) => source.pipe(first<PricingFeatureLoadedModel>(({ loaded }) => loaded));

export type ObservableReturnType<T> = T extends Observable<infer R> ? R : any;

export type ObjectWithObservableReturnTypes<T> = {
  [P in keyof T]: ObservableReturnType<T[P]>;
};

export function combineLatestProperties<TObj extends { [key: string]: ObservableInput<any> }>(
  observableObject: TObj,
): Observable<ObjectWithObservableReturnTypes<TObj>> {
  const keys = Object.keys(observableObject);
  return <Observable<ObjectWithObservableReturnTypes<TObj>>>combineLatest(
    keys.map(key => observableObject[key]),
  ).pipe(
    map(resultArray =>
      keys.reduce(
        (acc, key, index) => ({
          ...acc,
          [key]: resultArray[index],
        }),
        {},
      ),
    ),
  );
}
